module.exports = __webpack_public_path__ + "img/contact_1.f244377d.png";